import React, { useState, useEffect, useContext } from "react";

import PriceContext from "./price-context";
import { useHttpClient } from "../hooks/http-hook";
import fContext from "./f-context";
import {
  getGlazingPriceField,
  isGlazingEligible,
  isGlazingPriceEnabled,
  resolveGlazingSelection,
} from "../data/glazing";

const PriceContextProvider: React.FC = (props) => {
  const [priceList, setPriceList] = useState<Array<any> | null>(null);
  const [galleryRegularPrice, setGallerRegularPrice] = useState<Number>(0);
  const [galleryBasicPrice, setGalleryBasicPrice] = useState<Number>(0);
  const [galleryStandardPrice, setGalleryStandardPrice] = useState<Number>(0);
  const [gallerySelectionPrice, setGallerySelectionPrice] =
    useState<Number>(0);
  const [galleryCollectionPrice, setGalleryCollectionPrice] =
    useState<Number>(0);
  const [shippingPrice, setShippingPrice] = useState<Number>(6);
  const [expressPrice, setExpressPrice] = useState<Number>(12);
  const [finalRegularPrice, setFinalRegularPrice] = useState<Number>(0);
  const [finalBasicPrice, setFinalBasicPrice] = useState<Number>(0);
  const [finalStandardPrice, setFinalStandardPrice] = useState<Number>(0);
  const [finalSelectionPrice, setFinalSelectionPrice] = useState<Number>(0);
  const [finalCollectionPrice, setFinalCollectionPrice] = useState<Number>(0);
  const [priceDim, setPriceDim] = useState<any>(null);
  const { sendRequest } = useHttpClient();
  const fCtx = useContext(fContext);

  const populatePriceList = (price_list: Array<object>) => {
    setPriceList(price_list);
  };

  const fetchPricesSecond = async () => {
    try {
      //replace hardcoded eur by context variable
      const responseData = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + "api/shop/prices_eur"
      );
      return responseData.prices;
    } catch (err) {}
  };

  const getPricePerDim = (dim: Number) => {
    //assume list is ordered from smaller dim_cm to higher
    if (priceList === null || priceList.length < 1) {
      fetchPricesSecond();
      if (priceList === null || priceList.length < 1) {
        return {};
      } else {
        for (var j = 0; j < priceList.length; j++) {
          if (dim <= priceList[j].dim_cm) {
            return priceList[j];
          }
        }
        return { base_price: -1 };
      }
    } else {
      for (var k = 0; k < priceList.length; k++) {
        if (dim <= priceList[k].dim_cm) {
          return priceList[k];
        }
      }
      return { base_price: -1 };
    }
  };

  const getFinalPricing = (
    dim: Number,
    art_type: string,
    collection_moulding: boolean,
    basic_moulding: boolean,
    standard_moulding: boolean,
    selection_moulding: boolean,
    mount: string,
    mat_shape: string,
    mat_top?: number,
    mat_bottom?: number,
    mat_right?: number,
    mat_left?: number,
    glazing_selected?: string
  ) => {
    var priceList = getPricePerDim(dim);
    var final_price = 0;

    if (priceList) {
      if (priceList.base_price === -1) {
        final_price = -1;
      } else {
        final_price = priceList.base_price;

        if (art_type.includes("studio") || art_type === "studio") {
          final_price = priceList.studio_price;
        }

        if (mount === "floating" || mount === "box") {
          final_price += Number(priceList.mount_special || 0);
        }

        // Existing rule: italiano/oversized => pp_special
        if (mat_shape === "italiano" || mat_shape === "oversized") {
          final_price += Number(priceList.pp_special || 0);
        }

        // NEW RULE: standard/thin tiering using pp_standard / pp_special
        const matSum =
          Number(mat_top || 0) +
          Number(mat_bottom || 0) +
          Number(mat_right || 0) +
          Number(mat_left || 0);

        if (mat_shape === "standard" || mat_shape === "thin") {
          if (matSum >= 1 && matSum <= 20) {
            final_price += Number(priceList.pp_standard || 0);
          } else if (matSum > 20) {
            final_price += Number(priceList.pp_special || 0);
          }
        }

        // Add your existing custom rule unchanged ( > 28 pp_special  and <28 pp_standard pricing markup)
       if (
  mat_shape === "custom" &&
  mat_top !== undefined &&
  mat_bottom !== undefined &&
  mat_right !== undefined &&
  mat_left !== undefined
) {
  const matSum = mat_top + mat_bottom + mat_right + mat_left;

  if (matSum > 28) {
    final_price += Number(priceList.pp_special || 0);
  } else if (matSum < 28) {
    final_price += Number(priceList.pp_standard || 0);
  }
}

        if (art_type === "unmounted_canvas_studio") {
          final_price += Number(priceList.canvas_mount || 0);
        }

        const resolvedGlazing = resolveGlazingSelection(glazing_selected);
        const glazingPriceField = getGlazingPriceField(resolvedGlazing);
        if (
          glazingPriceField &&
          isGlazingEligible(art_type, mount) &&
          resolvedGlazing &&
          isGlazingPriceEnabled(priceList, resolvedGlazing)
        ) {
          final_price += Number(priceList[glazingPriceField] || 0);
        }

        if (collection_moulding) {
          final_price += Number(priceList.collection_moulding || 0);
        }
        if (basic_moulding) {
          final_price += Number(priceList.basic_moulding || 0);
        }
        if (standard_moulding) {
          final_price += Number(priceList.standard_moulding || 0);
        }
        if (selection_moulding) {
          final_price += Number(priceList.selection_moulding || 0);
        }
      }
    } else {
    }

    return final_price;
  };

  const calculatePrice = (priceDimList: any) => {
    setShippingPrice(priceDimList.shipping);
    setExpressPrice(priceDimList.express);

    if (priceDimList.base_price === -1) {
      setGallerRegularPrice(-1);
      setGalleryBasicPrice(-1);
      setGalleryStandardPrice(-1);
      setGallerySelectionPrice(-1);
      setGalleryCollectionPrice(-1);
      setFinalRegularPrice(-1);
      setFinalBasicPrice(-1);
      setFinalStandardPrice(-1);
      setFinalSelectionPrice(-1);
      setFinalCollectionPrice(-1);
    } else {
      var final_price = priceDimList.base_price;

      if (fCtx.artType.includes("studio") || fCtx.artType === "studio") {
        final_price = priceDimList.studio_price;
      }

      if (fCtx.artType === "unmounted_canvas_studio") {
        final_price += Number(priceDimList.canvas_mount || 0);
      }

      const resolvedGlazing = resolveGlazingSelection(fCtx.glazing);
      const glazingPriceField = getGlazingPriceField(resolvedGlazing);
      if (
        glazingPriceField &&
        isGlazingEligible(fCtx.artType, fCtx.mount) &&
        resolvedGlazing &&
        isGlazingPriceEnabled(priceDimList, resolvedGlazing)
      ) {
        final_price += Number(priceDimList[glazingPriceField] || 0);
      }

      setGallerRegularPrice(final_price);
      setGalleryBasicPrice(final_price + Number(priceDimList.basic_moulding || 0));
      setGalleryStandardPrice(
        final_price + Number(priceDimList.standard_moulding || 0)
      );
      setGallerySelectionPrice(
        final_price + Number(priceDimList.selection_moulding || 0)
      );
      setGalleryCollectionPrice(final_price + priceDimList.collection_moulding);

      if (fCtx.mount === "floating" || fCtx.mount === "box") {
        final_price += Number(priceDimList.mount_special || 0);
      }

      // Existing rule: italiano/oversized => pp_special
      if (fCtx.matShape === "italiano" || fCtx.matShape === "oversized") {
        final_price += Number(priceDimList.pp_special || 0);
      }

      // NEW RULE: standard/thin tiering using pp_standard / pp_special
      const matSum =
        Number(fCtx.matTop || 0) +
        Number(fCtx.matBottom || 0) +
        Number(fCtx.matRight || 0) +
        Number(fCtx.matLeft || 0);

      if (fCtx.matShape === "standard" || fCtx.matShape === "thin") {
        if (matSum >= 1 && matSum <= 20) {
          final_price += Number(priceDimList.pp_standard || 0);
        } else if (matSum > 20) {
          final_price += Number(priceDimList.pp_special || 0);
        }
      }

       // Add your existing custom rule unchanged ( > 28 pp_special  and <28 pp_standard pricing markup)
 if (fCtx.matShape === "custom") {
  const matSum =
    +fCtx.matTop + +fCtx.matBottom + +fCtx.matRight + +fCtx.matLeft;

  if (matSum > 28) {
    final_price += Number(priceDimList.pp_special || 0);
  } else if (matSum < 28) {
    final_price += Number(priceDimList.pp_standard || 0);
  }
}

      setFinalRegularPrice(final_price);
      setFinalBasicPrice(final_price + Number(priceDimList.basic_moulding || 0));
      setFinalStandardPrice(
        final_price + Number(priceDimList.standard_moulding || 0)
      );
      setFinalSelectionPrice(
        final_price + Number(priceDimList.selection_moulding || 0)
      );
      setFinalCollectionPrice(final_price + priceDimList.collection_moulding);
    }
  };

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        //replace hardcoded eur by context variable
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "api/shop/prices_eur"
        );
        populatePriceList(responseData.prices);
      } catch (err) {}
    };
    fetchPrices();
  }, [sendRequest]);

  useEffect(() => {
    const priceRange = async () => {
      if (fCtx.wSelected && fCtx.hSelected) {
        var dim = Number(fCtx.wSelected) + Number(fCtx.hSelected);

        //assume list is ordered from smaller dim_cm to higher
        if (priceList === null || priceList.length < 1) {
          fetchPricesSecond();
          if (priceList === null || priceList.length < 1) {
            setPriceDim({});
          } else {
            for (var j = 0; j < priceList.length; j++) {
              if (dim <= priceList[j].dim_cm) {
                setPriceDim(priceList[j]);
                calculatePrice(priceList[j]);
                return true;
              }
            }
            setPriceDim({ base_price: -1 });
            return true;
          }
        } else {
          for (var k = 0; k < priceList.length; k++) {
            if (dim <= priceList[k].dim_cm) {
              setPriceDim(priceList[k]);
              calculatePrice(priceList[k]);
              return true;
            }
          }
          setPriceDim({ base_price: -1 });
          return true;
        }
      }
    };
    priceRange();
  }, [fCtx.wSelected, fCtx.hSelected, priceList]);

  useEffect(() => {
    const finalPrice = async () => {
      if (priceDim) {
        calculatePrice(priceDim);
      }
    };
    finalPrice();
  }, [
    fCtx.artType,
    fCtx.mount,
    fCtx.glazing,
    fCtx.matShape,
    fCtx.matTop,
    fCtx.matBottom,
    fCtx.matRight,
    fCtx.matLeft,
    priceDim,
  ]);

  return (
    <PriceContext.Provider
      value={{
        priceList,
        galleryBasicPrice,
        galleryStandardPrice,
        gallerySelectionPrice,
        galleryCollectionPrice,
        galleryRegularPrice,
        finalRegularPrice,
        finalBasicPrice,
        finalStandardPrice,
        finalSelectionPrice,
        finalCollectionPrice,
        shippingPrice,
        expressPrice,
        populatePriceList,
        getPricePerDim,
        getFinalPricing,
      }}
    >
      {props.children}
    </PriceContext.Provider>
  );
};

export default PriceContextProvider;
